// extracted by mini-css-extract-plugin
export var error = "text-input-module--error--5f6a3";
export var errorText = "text-input-module--errorText--02fad";
export var fieldGroup = "text-input-module--fieldGroup--c1445";
export var label = "text-input-module--label--cfeb2";
export var textInput = "text-input-module--textInput--88fd1";